export default __webpack_public_path__ + "static/media/13-unpacking-principles.00f4da57.png";